import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

type ComponentsEmptyStateProps = {
  onOnboard: () => void;
};

const ComponentsEmptyState = ({ onOnboard }: ComponentsEmptyStateProps) => {
  return (
    <div className="flex min-h-[16rem] flex-col items-center justify-center rounded-[var(--inv-radius-card)] border border-dashed border-[var(--inv-border)] bg-[var(--inv-surface)]/60 px-8 py-12 text-center">
      <p className="m-0 text-[0.9375rem] text-[var(--inv-text-secondary)]">
        No components match your search or filter.
      </p>
      <Button type="button" onClick={onOnboard} className="mt-4 h-10 px-4 text-[0.875rem]">
        <Plus className="h-4 w-4" strokeWidth={2.25} aria-hidden="true" />
        Add repository
      </Button>
    </div>
  );
};

export default ComponentsEmptyState;
